import React from 'react'
import { Navbar, Nav, NavItem, Grid, Row, Col } from 'react-bootstrap'
import crabImg from '../images/crab.jpg'
import bcrabImg from '../images/bcrab.jpg'
import storefrontImg from '../images/storefront.jpg'
import './home.css'

const menuLink = '/Golden Spoon Menu_011024_190Art2sideMattLam.pdf'
const phoneNumber = 'tel:+6591185544'
const reserveLink = 'https://www.opentable.sg/r/de-golden-reservations-singapore?restref=284342&lang=en-US&ot_source=Restaurant%20website'

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = { expanded: false }
  }

  collapseNav = () => {
    this.setState({ expanded: false })
  }

  render() {
    return (
      <div>
        {/* ===== Navbar ===== */}
        <Navbar fixedTop expanded={this.state.expanded}>
          <Navbar.Header>
            <Navbar.Brand>
              <a href="/">De Golden Spoon</a>
            </Navbar.Brand>
            <Navbar.Toggle onClick={() => this.setState({ expanded: !this.state.expanded })} />
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav pullRight>
              <NavItem eventKey={1} href="/" onClick={this.collapseNav}>Home</NavItem>
              <NavItem eventKey={2} href={menuLink} onClick={this.collapseNav}>Menu</NavItem>
              <NavItem eventKey={3} href={phoneNumber} onClick={this.collapseNav}>Call Us</NavItem>
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        {/* ===== Hero ===== */}
        <section className="hero">
          <img className="hero-bg" src={crabImg} alt="Signature Crab Bee Hoon" />
          <div className="hero-overlay" />
          <div className="hero-content">
            <p className="hero-tagline">EST. SINGAPORE</p>
            <h1 className="hero-title">De Golden Spoon</h1>
            <div className="hero-divider" />
            <p className="hero-subtitle">Famous Crab Bee Hoon &amp; Seafood</p>
            <div className="hero-buttons">
              <a href={menuLink} className="btn-gold">View Our Menu</a>
              <a href={phoneNumber} className="btn-outline-white">Call to Reserve</a>
              <a href={reserveLink} target="_blank" rel="noopener noreferrer" className="btn-gold">Reserve Online</a>
            </div>
          </div>
        </section>

        {/* ===== About ===== */}
        <section className="about-section">
          <Grid>
            <Row>
              <Col xs={12} md={5}>
                <img className="about-img" src={storefrontImg} alt="De Golden Spoon storefront" />
              </Col>
              <Col xs={12} md={7}>
                <h2 className="about-heading">Welcome to De Golden Spoon</h2>
                <p className="about-text">
                  A beloved seafood restaurant in the heart of Singapore, renowned for
                  our signature Crab Bee Hoon Soup and fresh, flavourful dishes prepared
                  with passion.
                </p>
                <div className="hours-grid">
                  <div className="hours-card">
                    <h4>Lunch</h4>
                    <p>11:00 AM &ndash; 2:30 PM</p>
                  </div>
                  <div className="hours-card">
                    <h4>Dinner</h4>
                    <p>5:00 PM &ndash; 10:30 PM</p>
                  </div>
                </div>
                <p className="about-address">
                  <strong>Address:</strong> 62 Seng Poh Ln #01-11, Singapore 160062
                </p>
                <a href={phoneNumber} className="btn-ocean">
                  Call 9118 5544
                </a>
              </Col>
            </Row>
          </Grid>
        </section>

        {/* ===== Signature Dishes ===== */}
        <section className="dishes-section">
          <Grid>
            <h2 className="dishes-heading">Signature Dishes</h2>
            <p className="dishes-sub">Our most-loved creations, perfected over the years</p>
            <Row>
              <Col xs={12} sm={6}>
                <div className="dish-card">
                  <img className="dish-card-img" src={crabImg} alt="Crab Bee Hoon" />
                  <div className="dish-card-body">
                    <h3>Golden Spoon Crab Bee Hoon</h3>
                    <p>
                      Our iconic dish &mdash; fresh crab simmered in a rich, flavourful broth
                      with silky bee hoon noodles. The reason locals keep coming back.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={6}>
                <div className="dish-card">
                  <img className="dish-card-img" src={bcrabImg} alt="Black Pepper Crab" />
                  <div className="dish-card-body">
                    <h3>Black Pepper Crab</h3>
                    <p>
                      Wok-fried crab tossed in a bold, aromatic black pepper sauce.
                      A spicy favourite that packs a punch with every bite.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        </section>

        {/* ===== Menu CTA ===== */}
        <section className="menu-cta">
          <Grid>
            <h2>Explore Our Full Menu</h2>
            <p>From fresh seafood to classic favourites &mdash; something for everyone.</p>
            <a href={menuLink} className="btn-gold">View Menu (PDF)</a>
          </Grid>
        </section>

        {/* ===== Footer ===== */}
        <footer className="site-footer">
          <Grid>
            <Row>
              <Col xs={12} sm={4} className="footer-col">
                <div className="footer-brand">De Golden Spoon</div>
                <p className="footer-tagline">Famous Crab Bee Hoon &amp; Seafood</p>
              </Col>
              <Col xs={12} sm={4} className="footer-col">
                <div className="footer-heading">Visit Us</div>
                <p>62 Seng Poh Ln #01-11</p>
                <p>Singapore 160062</p>
                <p style={{ marginTop: 8 }}>Lunch: 11 AM &ndash; 2:30 PM</p>
                <p>Dinner: 5 PM &ndash; 10:30 PM</p>
              </Col>
              <Col xs={12} sm={4} className="footer-col">
                <div className="footer-heading">Contact</div>
                <p>
                  Phone: <a href={phoneNumber}>9118 5544</a>
                </p>
                <a href={phoneNumber} className="btn-gold" style={{ marginTop: 12, padding: '8px 20px', fontSize: 13 }}>
                  Call Now
                </a>
              </Col>
            </Row>
            <div className="footer-bottom">
              &copy; {new Date().getFullYear()} De Golden Spoon. All rights reserved.
            </div>
          </Grid>
        </footer>

        {/* ===== Mobile Sticky Call Bar ===== */}
        <div className="mobile-call-bar">
          <a href={phoneNumber}>
            &#9742; Call to Reserve &mdash; 9118 5544
          </a>
        </div>
      </div>
    )
  }
}

export default Home
